import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { cashPlanArrow, cashPlans } from "@/mocks/ppcare";

export default function CashPlanSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Payment Breakdown"
            title={
              <>
                Cash Paying Option <span className="text-accent-500">Plan</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-7 md:grid-cols-3">
          {cashPlans.map((plan, index) => (
            <Reveal key={plan.note} delay={index * 100}>
              <div className="flex h-full flex-col items-center rounded-lg border border-background-200 bg-background-50 p-8 text-center">
                <h3 className="text-4xl font-bold text-foreground-950 md:text-5xl">
                  {plan.percent ? (
                    <>
                      {plan.price}
                      <span className="text-accent-500">{plan.suffix}</span>
                    </>
                  ) : (
                    <>
                      <span className="text-accent-500">$</span>
                      {plan.price.replace("$", "")}{" "}
                      <span className="text-lg font-semibold text-foreground-500">
                        {plan.suffix}
                      </span>
                    </>
                  )}
                </h3>
                <div className="mt-6 flex items-center gap-3">
                  <img src={cashPlanArrow} alt="" className="h-4 w-auto object-contain" />
                  <span className="text-sm font-medium text-foreground-700">{plan.note}</span>
                </div>
                <div className="my-7 h-px w-full bg-background-200" />
                <a
                  href="#contact"
                  className="mt-auto inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  Join Now
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}